import { strokeWidth } from "apparatus/draw";
import { P } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
import { Random } from "random/random";
export class Beads {
    render(appearance) {
        const { boundDiameter, color, diameter } = appearance;
        const outlineColor = color.color().ladd(-10).hex();
        const radius = diameter / 2;
        const boundRadius = boundDiameter / 2;
        const graphic = new Group();
        const step = 15;
        const r = new Random();
        for (let x = -boundRadius; x < boundRadius; x += step) {
            for (let y = -boundRadius; y < boundRadius; y += step) {
                const position = P(x, y).add(r.randomUniformVector(step / 3));
                if (position.length > boundRadius)
                    continue;
                const bacteria = Shape.Circle(position, radius);
                bacteria.withFill(color).withStroke(strokeWidth("default"), outlineColor);
                graphic.addChild(bacteria);
            }
        }
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: P(0, 0),
            xray: new Path.Circle(P(0, 0), boundRadius + radius),
        };
    }
}
Beads.properties = {
    label: "Beads",
    defaultAppearance: {
        diameter: 10,
        boundDiameter: 100,
        color: "#72b52f"
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "diameter", label: "Diameter",
            min: 4, max: 16, unit: "mm",
        },
        {
            spec: "slider", key: "boundDiameter", label: "Contained within",
            min: 25, max: 150, unit: "mm"
        },
        {
            spec: "color", key: "color", label: "Colour",
        }
    ],
};
